import { CustomPageType } from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { useApiClientContext } from '../../surveys/context';

const QUERY_KEY = 'SharedFileLink/byToken/custom-page-style';

interface ICustomPageStyleResponse {
	html?: string;
	hasCustomization: boolean;
	error?: string;
}

export const useSharedFileLinkPageStyleByToken = ({
	token,
	type,
	enabled = true,
}: {
	token?: string;
	type: CustomPageType;
	enabled?: boolean;
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery<ICustomPageStyleResponse>({
		enabled: enabled && !!token,
		queryFn: async (): Promise<ICustomPageStyleResponse> => {
			try {
				const response = await fetch(
					`${apiClient.baseUrl}/sharedFileLink/byToken/custom-page-style/${type}?${toQueryString({ token })}`
				);

				if (!response.ok) {
					if (response.status === 404) {
						return { hasCustomization: false };
					}
					return { hasCustomization: false, error: `HTTP ${response.status}: ${response.statusText}` };
				}

				const htmlContent = await response.text();

				if (!htmlContent || htmlContent.trim() === '') {
					return { hasCustomization: false };
				}

				return { hasCustomization: true, html: htmlContent };
			} catch (networkError) {
				// eslint-disable-next-line no-console
				console.error('Failed to fetch shared file link custom page style:', networkError);
				return { hasCustomization: false };
			}
		},
		queryKey: [QUERY_KEY, token, type],
		retry: false,
	});
};
